import { useAbility } from '@casl/react';

import { Permission } from '@/api/client';

/**
 * Custom hook to check if the current user has permission to perform an action on a resource
 * @param permissions - The permissions to check
 * @param condition - The condition to check the permissions with
 * @returns True if the user has permission, false otherwise
 */
export const usePermission = (
  permissions: Permission | Permission[],
  condition: 'any' | 'all' = 'any'
) => {
  const ability = useAbility();
  if (Array.isArray(permissions)) {
    if (condition === 'any') {
      return permissions.some((permission) =>
        ability.can(permission.action, permission.resource)
      );
    } else {
      return permissions.every((permission) =>
        ability.can(permission.action, permission.resource)
      );
    }
  } else {
    return ability.can(permissions.action, permissions.resource);
  }
};
